import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import React, {useRef, useState} from "react";
import {v4} from "uuid";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import bloodmagic_items from "../../_data/bloodmagic_items";
import {ICharBloodMagicItem} from "../../_interfaces/ICharBloodMagicItem";
import {s_char, s_char_bloodmagicitems} from "../../_signals/s_char";
import {BloodMagicItemCreate} from "../../_api/BEBloodMagicItems";
import {useSignals} from "@preact/signals-react/runtime";
import {IDataBloodmagicItem} from "../../_interfaces/IDataBloodmagicItem";

interface IProp {
    open: boolean,
    isOpen: (open: boolean) => void
}

export default function BloodMagicItemsAdd({open, isOpen}: IProp) {
    useSignals()
    const descrRef = useRef<HTMLInputElement>(null);
    const [name, setName] = useState('')
    const [itemstate, setItemState] = useState(0)
    const [itemData, setItemData] = useState<IDataBloodmagicItem | null>(null)

    const save = () => {

        const item = bloodmagic_items.find(i => i.name === name)
        if (!item) return
        const addbloodmagic: ICharBloodMagicItem = {
            id: v4(),
            cid: s_char.value.id,
            name: name,
            descr: descrRef.current?.value ?? '',
            dmg: item.dmg ?? 0,
            state: itemstate,
            strain: item.strain ?? 0,
            active: false
        };

        s_char_bloodmagicitems.value = [...s_char_bloodmagicitems.value, addbloodmagic]
        BloodMagicItemCreate(addbloodmagic)
        isOpen(false)
    }


    return <Dialog open={open}>
        <DialogContent>
            <Select defaultValue={''}
                    style={{width: "100%"}}
                    onChange={(e) => {
                        const sname = e.target.value
                        setName(sname)
                        const item = bloodmagic_items.find(i => i.name === sname)
                        setItemData(item ?? null)
                    }}>
                {bloodmagic_items.map(m => <MenuItem key={v4()} value={m.name}>{m.name}</MenuItem>)}
            </Select>
            <TextField defaultValue={''}
                       label={'Beschreibung'}
                       inputRef={descrRef}
                       variant="standard"
                       multiline
                       rows={3}
                       style={{width: '100%'}}
            />
            <Select value={itemstate}
                    style={{width: "100%"}}
                    onChange={(e) => setItemState(e.target.value as number)}
            >
                <MenuItem key={v4()} value="0">ungebunden</MenuItem>
                <MenuItem key={v4()} value="1">gebunden</MenuItem>
                <MenuItem key={v4()} value="2">benutzt</MenuItem>
            </Select>
            {itemData ?
                <>
                    <div>{itemData.desc}</div>
                    <div>Schaden: {itemData.dmg}</div>
                    <div>{itemData.avail}</div>
                </>

                : null}
            {itemData && itemData.strain_mods ?
                itemData.strain_mods.map(sm =>
                    <>
                        <div>{sm.what}</div>
                        <div>{sm.mod}</div>
                        <div>{sm.type}</div>
                        <div>{sm.duration}</div>
                    </>
                )
                : null}
        </DialogContent>
        <DialogActions>
            <Button className={'btn'} id="post" onClick={() => save()}><CheckIcon/></Button>
            <Button className={'btn'} id="post" onClick={() => isOpen(false)}><ClearIcon/></Button>

        </DialogActions>
    </Dialog>


}
